import { ValidationErrorResponse } from '../types/ValidationErrorResponse';

export const isValidationErrorResponse = (object: any | ValidationErrorResponse): object is ValidationErrorResponse => {
  if (object === null || object === undefined) return false;
  const errors = (object as ValidationErrorResponse).Errors;

  const hasErrorsArray = Array.isArray(errors);
  if (!hasErrorsArray) return false;

  const hasValidationFailureErrors = errors.every(error => error.code && error.message && error.severity);

  return hasValidationFailureErrors;
};
